import { render, staticRenderFns } from "./userDetailModal.vue?vue&type=template&id=032d8ba2&scoped=true"
import script from "./userDetailModal.vue?vue&type=script&lang=js"
export * from "./userDetailModal.vue?vue&type=script&lang=js"
import style0 from "./userDetailModal.vue?vue&type=style&index=0&id=032d8ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d8ba2",
  null
  
)

export default component.exports